import { forwardRef, type ComponentPropsWithoutRef } from 'react';
import { createPath, type To } from 'react-router';
import { useNavigate } from '../routing/navigate';

export interface LinkProps extends Omit<ComponentPropsWithoutRef<'a'>, 'href'> {
  replace?: boolean;
  to: To;
}

export const Link = forwardRef<HTMLAnchorElement, LinkProps>(function Link(
  { children, onClick, replace, to, ...props },
  ref
): JSX.Element {
  const navigate = useNavigate();
  const url = typeof to === 'string' ? to : createPath(to);
  const isExternal = /^https?:\/\//.test(url) || url.startsWith('//');

  const onClickHandler = (event: React.MouseEvent<HTMLAnchorElement>) => {
    onClick?.(event);

    if (!isExternal) {
      event.preventDefault();
      navigate(to, { replace });
    }
  };

  return (
    <a ref={ref} href={url} onClick={onClickHandler} {...props}>
      {children}
    </a>
  );
});
